import { faAngleLeft, faAngleRight, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import axios from 'axios'
import moment from 'moment'
import { Component } from 'react'
import { Card, Container, Form, Offcanvas, Spinner } from 'react-bootstrap'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import { GET, POST } from '../../api'
import person1 from '../../assets/images/person-1.png'
import person3 from '../../assets/images/person-3.png'
import person4 from '../../assets/images/person-4.png'
import { AmericanSilver, Argent, Black, Blueberry, BlueCrayola, CyanProcess, GoldenPoppy, Purple, RedLustre, White, WhiteMarble } from '../../helpers/brand_colors_helper'
import { makeURL } from '../../helpers/general_helpers'
import GeneralCard from '../../helpers/GeneralCard'
import GetIcon from '../../helpers/icon_helper'
import { getRegionalStorageURL } from '../../helpers/regional_storage_url_helper'
import { t } from '../../helpers/translation_helper'
import { unsetAuthentication } from '../../redux/slices/authSlice'
import { setDefaultLanguage } from '../../redux/slices/langSlice'
import { setSelectedChild } from '../../redux/slices/selectedChildSlice'
import Header from '../_partials/Header/_Header'
import NavBar from '../_partials/NavBar/_NavBar'
import './dashboard.css'
import Timeline from './Timeline'
import Timetable from './Timetable'

// API URL
const apiURL = process.env.REACT_APP_API_URL

// Portal URL
const portalURL = process.env.REACT_APP_PORTAL_URL

let controller // For axios abort controller

/**
 * Dashboard Component
 */
class Dashboard extends Component {
  /**
   * @constructor
   * @param {any} props
   */
  constructor(props) {
    super(props)

    // MISSING UT TYPES
    // Exam Retake
    // Medication Consent
    // 'BMI', 'Medicine Dose', 'Academic Lesson', 'Pastoral Care', 'Daily Activity',  'Registration', 'Engage'

    const defaultUtTypes = [
      {
        label: "Notification",
        value: "Notification",
        picture: require('../../assets/images/user-timeline/notification.png'),
        active: true,
      },
      {
        label: "Event",
        value: "Event",
        picture: require('../../assets/images/user-timeline/event.png'),
        active: true,
      },
      {
        label: "Newsletter",
        value: "Newsletter",
        picture: require('../../assets/images/user-timeline/newsletter.png'),
        active: true,
      },
      {
        label: "Media",
        value: "Media",
        picture: require('../../assets/images/user-timeline/photos.png'),
        active: true,
      },
      {
        label: "Video",
        value: "Video",
        picture: require('../../assets/images/user-timeline/videos.png'),
        active: true,
      },
      {
        label: "Note",
        value: "Note",
        picture: require('../../assets/images/user-timeline/attachment-pink.png'),
        active: true,
      },
      {
        label: "Online Class",
        value: "Online Class",
        picture: require('../../assets/images/user-timeline/online-class.png'),
        active: true,
      },
      {
        label: "Resources",
        value: "Resources",
        picture: require('../../assets/images/user-timeline/download.png'),
        active: true,
      },
      {
        label: "Policy",
        value: "Policy",
        picture: require('../../assets/images/user-timeline/policy.png'),
        active: true,
      },
      {
        label: "Incident Report",
        value: "Incident Report",
        picture: require('../../assets/images/user-timeline/nurse-2.png'),
        active: true,
      },
      {
        label: "Poll",
        value: "Poll",
        picture: require('../../assets/images/user-timeline/poll.png'),
        active: true,
      },
      {
        label: "Survey",
        value: "Survey",
        picture: require('../../assets/images/user-timeline/survey.png'),
        active: true,
      },
      {
        label: "Observation",
        value: "Assessment",
        picture: require('../../assets/images/user-timeline/grade.png'),
        active: true,
      },
      {
        label: "Monthly Observation",
        value: "CheckList",
        picture: require('../../assets/images/user-timeline/grade.png'),
        active: true,
      },
      {
        label: "Agenda",
        value: "Agenda",
        picture: require('../../assets/images/user-timeline/agenda.png'),
        active: true,
      },
      {
        label: "Assignment",
        value: "Assignment",
        picture: require('../../assets/images/user-timeline/assignment.png'),
        active: true,
      },
      {
        label: "Daily Report",
        value: "Daily Report",
        picture: require('../../assets/images/user-timeline/daily-report.png'),
        active: true,
      },
      {
        label: "Exam",
        value: "Exam",
        picture: require('../../assets/images/user-timeline/exam.png'),
        active: true,
      },
      {
        label: "Homework",
        value: "Online Homework",
        picture: require('../../assets/images/user-timeline/exam.png'),
        active: true,
      },
      {
        label: "Activity",
        value: "Academic Activity",
        picture: require('../../assets/images/user-timeline/activity.png'),
        active: true,
      },
      {
        label: "Result",
        value: "Result",
        picture: require('../../assets/images/user-timeline/awards.png'),
        active: true,
      },
      {
        label: "Announcement",
        value: "Announcement",
        picture: require('../../assets/images/user-timeline/notification.png'),
        active: true,
      },
    ]

    this.state = {
      utWorking: false,
      startDate: '',
      endDate: '',
      utTypes: defaultUtTypes,
      selectedUtTypes: defaultUtTypes,
      userTimelineData: [],
      offset: 0,
      loadMore: false,
      subjects: null,
      searchSubject: '',
      // calendarList: null
      calendarList: [],
      examsList: [],
      showUT: false,
    }
  }

  /**
   * Component Did Mount
   */
  componentDidMount() {
    this.getSubjects()
    this.getCalendar()
    this.getExamsCalendar()
  }

  /**
   * Handle Selected User Timeline Types
   * @param {array} types Array of user timeline types.
   */
  handleSelectUtTypes = (types) => {
    this.setState({
      selectedUtTypes: types,
    })
  }

  /**
   * Handle Date Range
   * @param {string} dateType Name of the date field in state
   * @param {any} date Date
   */
  handleUtDateRange = (dateType, date) => {
    this.setState({
      [dateType]: date,
    })
  }

  /**
   * Get Timeline
   * @param {boolean} reset Reset the filter
   */
  getTimeline = async (reset = false) => {
    if (this.state.finishedData || this.state.loadMore) {
      return false
    }
    this.setState({
      loadMore: true,
    }, async () => {

      if (this.state.offset === 0) {
        this.setState({ utWorking: true })
      }

      if (this.getTimelineReq) { this.getTimelineReq.abort(); }
      this.getTimelineReq = new AbortController();

      const { selectedUtTypes, startDate, endDate, userTimelineData } =
        this.state
      const { authData, selectedChild } = this.props
      const { class_id, child_id } = selectedChild
      const { center_id, center_timezone } = authData.centerData
      const { user_id, auth_key } = authData.loginData

      const fData = new FormData()
      fData.append('user_id', user_id)
      fData.append('center_id', center_id)
      fData.append('center_timezone', center_timezone)
      fData.append('class_id', class_id)
      fData.append('child_id', child_id)
      fData.append('activeFilterDateFrom', startDate ? moment(startDate).format('YYYY-MM-DD') + ' 00:00:00' : 'null')
      fData.append('activeFilterDateTo', endDate ? moment(endDate).format('YYYY-MM-DD') + ' 23:59:59' : 'null')
      fData.append('selectedTimelineTypes', JSON.stringify(selectedUtTypes.map((item) => { return { ut_type: item.value, active: true } })))
      fData.append('offset', this.state.offset)

      try {
        const req = await POST('user-timeline', fData, {
          params: {
            auth_key: auth_key,
          },
          signal: this.getTimelineReq.signal,
        })

        if (req.status === 200) {
          let data = []
          if (reset) {
            data = req.data
          } else {
            data = [...userTimelineData, ...req.data]
          }

          this.setState({
            utWorking: false,
            userTimelineData: data,
            offset: this.state.offset + 10,
            loadMore: false,
            finishedData: (req.data.length <= 0) ? true : false
          })
          // setTimeout(() => {
          //     if (document.querySelector('.timeline-reel')) {
          //         document
          //             .querySelector('.timeline-reel')
          //             .setAttribute(
          //                 'style',
          //                 'height:' +
          //                     (document.querySelector(
          //                         '.page-content-inner'
          //                     ).offsetHeight -
          //                         60) +
          //                     'px'
          //             )
          //     }
          // }, 1000)
        }
      } catch (err) {
        if (axios.isCancel(err)) {
          // console.log('Request canceled', err.message)
        } else {
          toast.error('Something went wrong while fetching news feed!')
          // console.log(err)
        }
      }
    })
  }

  handleOpenUT = () => {
    this.setState({
      showUT: true,
      startDate: '',
      endDate: '',
      offset: 0,
      finishedData: false,
      selectedUtTypes: this.state.utTypes,
    }, () => this.getTimeline(true))

  }

  handleCloseUT = () => {
    this.setState({
      showUT: false,
      userTimelineData: [],
    })
  }

  /**
   * Get Subjects
   */
  getSubjects = async () => {
    this.setState({ subjects: null })
    const { authData, selectedChild } = this.props
    const { class_id, class_theme, agegroup_id } = selectedChild
    const { center_id } = authData.centerData
    const { auth_key } = authData.loginData

    const params = {
      class_id,
      center_id,
      agegroup_id,
      class_theme,
      auth_key: auth_key,
    }

    try {
      const res = await GET('academic-subject-lessons/get-subjects',
        {
          params,
        }
      )

      this.setState({
        subjects: res.data.data,
      })
    } catch (err) {
      toast.error('Something went wrong while fetching subjects!')
      // console.log(err)
    }
  }

  /**
   * Render Subjects SLides
   * @returns {HTMLElement} Renders subjects slides
   */
  renderSubjects = () => {
    const { subjects } = this.state
    const subjectsItems = subjects.map((v, i) => {

      let data = {
        allData: v,
        name: v.acs_name,
        code: v.acs_code,
        text1: (v.parent_acs_name) ? 'Focus:' : null,
        text2: v.parent_acs_name,
        description: v.acs_desc,
        // linkTo: '/subject/lessons/' + v.acs_name,
        // linkToStates: { as_id: v.as_id, acs_id: v.acs_id, ab_id: v.ab_id, },
        linkTo: '/subject/' + v.acs_id,
        cardImage: (v.acs_image) ? getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_classmain_subject/' + v.acs_image : require('../../assets/images/noimage.png'),
        extraTexts: [
          { type: 'url', name: 'URL', value: v.acs_url, iconName: null, image: require('../../assets/images/hyperlink.png'), iconColor: Black, onClick: () => { } },
          { type: 'text', name: 'Type', value: (v.acs_mandatory == 1) ? 'Mandatory' : 'Elective', icon: null, image: require('../../assets/images/asterisk.png'), iconColor: Black, onClick: () => { } }
        ],
        actions: []
      }
      if (v.acs_url) {
        data.actions.push({
          type: 'openTab', name: 'Open Url in a pop-up', image: null, iconName: faArrowUpRightFromSquare, iconColor: GoldenPoppy, onClick: () => {
            window.open(makeURL(v.acs_url), '', 'width=800,height=600')
          }
        })
        data.actions.push({
          type: 'open', name: 'Open Url in a New Tab', image: null, iconName: faArrowUpRightFromSquare, iconColor: Blueberry, onClick: () => {
            window.open(makeURL(v.acs_url), '_blank')
          }
        })
      }
      return <GeneralCard data={data} key={i} />

      // let image = null

      // if (item.acs_image) {
      //   image =
      //     getRegionalStorageURL() + 
      //     item.center_id +
      //     '/academic_classmain_subject/' +
      //     item.acs_image
      // }

      // return (
      //   <div className='three-slide' key={index}>
      //     <Link to={'/subject/' + item.acs_id + '/' + item.acs_name}>
      //       <div className='slide-inner'>
      //         <div
      //           className='subject-image'
      //           style={{
      //             backgroundImage: `url(${image || u2})`,
      //           }}></div>
      //         <h6>{item.acs_name}</h6>
      //       </div>
      //     </Link>
      //   </div>
      // )
    })
    return subjectsItems
  }

  /**
   * Reset Filter
   */
  resetFilter = () => {
    this.setState(
      {
        startDate: '',
        endDate: '',
        offset: 0,
        finishedData: false,
        selectedUtTypes: this.state.utTypes,
      },
      () => this.getTimeline(true)
    )
  }

  applyFilter = () => {
    this.setState(
      {
        offset: 0,
        finishedData: false
      },
      () => this.getTimeline(true)
    )
  }

  /**
    * Get Calendar
    */
  getCalendar = async () => {
    this.setState({
      calendarList: null,
    })
    const { auth_key, center_id } = this.props.authData.loginData
    const { class_id } = this.props.selectedChild

    let request_params = {
      center_id,
      class_id,
      auth_key,
      date: moment().format('YYYY-MM-DD'),
      child_id: this.props.selectedChild.child_id
    }

    try {
      const res = await GET('center-calendar/get-center-calendar-day',
        {
          params: request_params,
        }
      )

      this.setState({
        calendarList: res.data,
      })

    } catch (err) {
      toast.error('Something went wrong while fetching calendar!')
      // console.log(err)
    }
  }

  /**
  * Get Exams Calendar
  */
  getExamsCalendar = async () => {
    this.setState({
      examsList: null,
    })
    const { auth_key, center_id } = this.props.authData.loginData
    const { class_id } = this.props.selectedChild

    let request_params = {
      center_id,
      class_id,
      auth_key,
      date: moment().format('YYYY-MM-DD'),
    }

    try {
      const res = await GET('dashboard/get-exams-calendar-day',
        {
          params: request_params,
        }
      )

      this.setState({
        examsList: res.data.data,
      })

    } catch (err) {
      toast.error('Something went wrong while fetching exams calendar!')
      // console.log(err)
    }
  }

  /**
   * Render Component
   * @returns {HTMLElement}
   */
  render() {
    // Language Direction
    const { lang_orientation: dir } = this.props.defaultLanguage
    // State
    const { utWorking, startDate, endDate, utTypes, selectedUtTypes, userTimelineData, loadMore, subjects, searchSubject } = this.state

    const firstRow = [
      { name: 'Exam Hall', image: require('../../assets/images/exams.png'), onClick: '/exams' },
      { name: 'Home Work', image: require('../../assets/images/homework.png'), onClick: '/homework' },
      { name: 'Class Blog', image: require('../../assets/images/classblog.png'), onClick: '/class-blog' },
      { name: 'Activities', image: require('../../assets/images/activities.png'), onClick: '/activities' },
    ]
    const secondRow = [
      { name: 'CAS', image: person1, onClick: '/cas' },
      { name: 'Essay', image: person4, onClick: '/essay' },
      { name: 'TOK', image: person3, onClick: '/tok' },
    ]
    return (
      <>
        <Container fluid>
          <div id='iedu-layout'>
            <NavBar />
            <div id='page-content' style={{ padding: (dir == 1) ? '20px 118px 20px 10px' : '20px 10px 20px 118px' }}>
              <div className='page-content-inner'>
                <Header func={[this.resetFilter, this.getSubjects]} />

                <div className='grey-section mb-0 p-3' style={{ height: '84vh' }}>
                  <div className='d-flex flex-row' style={{ height: '100%' }}>
                    {/* LEFT */}
                    <div style={{ borderRight: 'solid 1px ' + Argent, width: '70%', height: '100%', overflowY: 'auto' }} className='pe-2 me-2'>
                      {/* EXAMS */}
                      <div className='d-flex flex-row align-items-center' style={{ width: '100%' }}>
                        {firstRow.map((firstRow_v, firstRow_i) => {
                          return <div style={{ width: '25%' }} className='px-1'>
                            <Link to={firstRow_v.onClick} style={{ textDecoration: 'none' }}>
                              <Card className='dash-card1 hover-border-primary' style={{ borderRadius: 25, border: 'solid 1px ' + White, height: 100, fontSize: 14 }}>
                                <Card.Body className='p-3 overflow-hidden position-relative cursor-pointer'>
                                  <div className='d-flex flex-wrap flex-row' style={{ fontWeight: 'bold', width: '50%' }}>{firstRow_v.name}</div>
                                  <div className='card-image'>
                                    <img src={firstRow_v.image} style={{ height: 100, width: 100 }} />
                                  </div>
                                </Card.Body>
                              </Card>
                            </Link>
                          </div>
                        })}
                      </div>
                      {/* TOK CAS ESSAY */}
                      <div className='d-flex flex-row align-items-center mt-2' style={{ width: '100%' }}>
                        {secondRow.map((secondRow_v, secondRow_i) => {
                          return <div style={{ width: '25%' }} className='px-1'>
                            <Link to={secondRow_v.onClick} style={{ textDecoration: 'none' }}>
                              <Card className='dash-card2 hover-border-primary' style={{ borderRadius: 25, border: 'solid 1px ' + White, height: 50, fontSize: 12 }}>
                                <Card.Body className='p-3 overflow-hidden position-relative cursor-pointer' onClick={secondRow_v.onClick}>
                                  <div className='d-flex flex-wrap flex-row' style={{ fontWeight: 'bold', width: '50%' }}>{secondRow_v.name}</div>
                                  <div className='card-image'>
                                    <img src={secondRow_v.image} style={{ height: 50, width: 50 }} />
                                  </div>
                                </Card.Body>
                              </Card>
                            </Link>
                          </div>
                        })}
                      </div>
                      {/* TASKS */}
                      <div className='mt-2' style={{ width: '100%' }}>
                        <Card className='p-0' style={{ borderRadius: 10, borderWidth: 0, minHeight: 50, fontSize: 12 }} >
                          <Card.Body className='p-2 overflow-hidden position-relative' >
                            <div className='d-flex flex-row align-items-center justify-content-between mb-2'>
                              <div className="px-2" style={{ fontWeight: 'bold', fontSize: 14 }}>Tasks</div>
                              <div className="px-2 d-flex flex-row align-items-center">
                                <div style={{ backgroundColor: WhiteMarble, color: Black, padding: '5px 10px', borderRadius: 5, fontSize: 11 }} className='d-flex flex-row align-items-center me-2'>
                                  <GetIcon icon={'LuCalendar1'} className={'me-1'} style={{ fontSize: 14 }} />
                                  {moment().format('dddd, DD MMM YYYY')}
                                </div>
                                <div>
                                  <Link to='/calendar' style={{ textDecoration: 'none' }}>
                                    <GetIcon icon="LuExternalLink" style={{ color: BlueCrayola }} />
                                  </Link>
                                </div>
                              </div>
                            </div>
                            <div className='grey-section mb-0 p-1' style={{ minHeight: '20vh', borderRadius: 5, }}>
                              {(() => {
                                const addTypesList = [
                                  { active: true, add_type: 'online_class', bgColor: '#b43bef', fontColor: '#fff', name: 'Online Class' },
                                  { active: true, add_type: 'exams', bgColor: '#FA7E85', fontColor: '#fff', name: 'Exams' },
                                  { active: true, add_type: 'stdassign', bgColor: '#FF00C6', fontColor: '#fff', name: 'Assignments' },
                                  // { active: true, add_type: 'events', bgColor: '#00C0FE', fontColor: '#fff', name: 'Events' },
                                  { active: true, add_type: 'calendar', bgColor: '#FE9738', fontColor: '#fff', name: 'Calendar Entry' },
                                  { active: true, add_type: 'agenda', bgColor: '#00B54A', fontColor: '#fff', name: 'Agenda Entry' },
                                  { active: true, add_type: 'classwork', bgColor: '#9fdb4a', fontColor: '#000', name: 'Class Work' },
                                  { active: true, add_type: 'homework', bgColor: '#166FF6', fontColor: '#fff', name: 'HomeWork' },
                                  { active: true, add_type: 'academic_activities', bgColor: '#6441c7', fontColor: '#fff', name: 'Academic Activity' },
                                  // { active: true, add_type: 'holiday', bgColor: '#FA7E85', fontColor: '#fff', name: 'Holiday' },
                                  { active: true, add_type: 'public', bgColor: '#00C0FE', fontColor: '#000', name: 'Public' },
                                ];

                                const activeTaskFilter = this.state.taskFilter || 'all';
                                const filteredCalendarList = (this.state.calendarList || []).filter((item) => {
                                  if (activeTaskFilter === 'all') return true;
                                  return (item.add_type || '').toLowerCase() === activeTaskFilter.toLowerCase();
                                });

                                return (
                                  <>
                                    {/* FILTER TABS */}
                                    <div
                                      className='d-flex flex-row align-items-center mb-2 px-1'
                                      style={{
                                        overflowX: 'auto',
                                        whiteSpace: 'nowrap',
                                        gap: 6,
                                        scrollbarWidth: 'none',
                                        msOverflowStyle: 'none'
                                      }}
                                    >
                                      <div
                                        role="button"
                                        onClick={() => this.setState({ taskFilter: 'all' })}
                                        style={{
                                          backgroundColor: activeTaskFilter === 'all' ? BlueCrayola : 'transparent',
                                          color: activeTaskFilter === 'all' ? White : '#64748b',
                                          border: '1px solid ' + (activeTaskFilter === 'all' ? BlueCrayola : '#cbd5e1'),
                                          borderRadius: 6,
                                          padding: '3px 14px',
                                          fontSize: 11,
                                          fontWeight: activeTaskFilter === 'all' ? 600 : 400,
                                          cursor: 'pointer',
                                          userSelect: 'none',
                                          transition: 'all 0.2s ease-in-out'
                                        }}
                                      >
                                        {t('All')}
                                      </div>
                                      {addTypesList.map((tab, tabIdx) => {
                                        const isSelected = activeTaskFilter === tab.add_type;
                                        return (
                                          <div
                                            key={tabIdx}
                                            role="button"
                                            onClick={() => this.setState({ taskFilter: isSelected ? 'all' : tab.add_type })}
                                            style={{
                                              backgroundColor: isSelected ? tab.bgColor : 'rgba(255, 255, 255, 0.7)',
                                              color: isSelected ? (tab.fontColor || White) : tab.bgColor,
                                              border: '1px solid ' + tab.bgColor,
                                              borderRadius: 6,
                                              padding: '3px 12px',
                                              fontSize: 11,
                                              fontWeight: isSelected ? 600 : 500,
                                              cursor: 'pointer',
                                              userSelect: 'none',
                                              whiteSpace: 'nowrap',
                                              transition: 'all 0.2s ease-in-out'
                                            }}
                                          >
                                            {tab.name}
                                          </div>
                                        );
                                      })}
                                    </div>

                                    {/* TASK ITEMS LIST */}
                                    {!this.state.calendarList &&
                                      <div style={{ textAlign: 'center' }}>
                                        <Spinner animation="grow" />
                                      </div>
                                    }
                                    {this.state.calendarList && filteredCalendarList.length === 0 &&
                                      <div style={{ textAlign: 'center' }}>
                                        {t('No Data Found!')}
                                      </div>
                                    }
                                    {this.state.calendarList && filteredCalendarList.length > 0 && filteredCalendarList.map((item, index) => {
                                      const body = (item.body) ? item.body.replace(/(<([^>]+)>)/gi, "") : item.body
                                      // console.log('item', item);

                                      const typeConfig = addTypesList.find(t => (t.add_type || '').toLowerCase() === (item.add_type || '').toLowerCase()) || {
                                        name: (item.add_type || '').replace(/_/g, ' ').toUpperCase(),
                                        bgColor: BlueCrayola,
                                        fontColor: White
                                      };

                                      return (
                                        <div
                                          key={index}
                                          style={{
                                            backgroundColor: White,
                                            borderRadius: 8,
                                            border: 'solid 1px #eef2f6',
                                            borderLeft: 'solid 4px ' + typeConfig.bgColor,
                                            fontSize: 12,
                                            minHeight: 40
                                          }}
                                          className='px-3 py-2 d-flex flex-row justify-content-between align-items-center mb-2'
                                        >
                                          <div className='d-flex flex-row align-items-center' style={{ flex: 1, minWidth: 0 }}>
                                            <div
                                              style={{
                                                color: typeConfig.bgColor,
                                                fontWeight: 600,
                                                minWidth: 120,
                                                maxWidth: 130,
                                                fontSize: 12
                                              }}
                                              className='text-truncate me-2'
                                            >
                                              {typeConfig.name}
                                            </div>
                                            <div
                                              className='text-truncate flex-grow-1 pe-2'
                                              style={{ color: '#1e293b', fontWeight: 500, fontSize: 13 }}
                                              title={item.title}
                                            >
                                              {item.title}
                                              {/* - {(body && body.length > 50) ? body.substring(0, 50) + '...' : body} */}
                                            </div>
                                          </div>
                                          <div className='d-flex flex-row align-items-center ms-auto' style={{ flexShrink: 0 }}>
                                            {item.acs_name && (
                                              <div
                                                style={{
                                                  backgroundColor: CyanProcess,
                                                  color: White,
                                                  padding: '2px 10px',
                                                  borderRadius: 6,
                                                  fontSize: 11,
                                                  fontWeight: 500
                                                }}
                                                className='me-2'
                                              >
                                                {item.acs_name}
                                              </div>
                                            )}
                                            <div>
                                              <Link to='/calendar' style={{ textDecoration: 'none' }}>
                                                <GetIcon icon="LuExternalLink" style={{ color: BlueCrayola }} />
                                              </Link>
                                            </div>
                                          </div>
                                        </div>
                                      )
                                    })}
                                  </>
                                );
                              })()}
                            </div>
                          </Card.Body>
                        </Card>
                      </div>
                      {/* SUBJECTS */}
                      {(subjects && subjects.length > 0) &&
                        <div className='d-flex flex-row align-items-start flex-wrap mt-2' style={{ width: '100%' }}>
                          <div style={{ width: '100%' }} className='px-1 mb-2 position-relative'>
                            <Form.Control type='text' placeholder={t('SEARCH SUBJECT...')} style={{ borderRadius: 50, padding: '5px 15px', fontSize: 12 }} value={searchSubject} onChange={(e) => this.setState({ searchSubject: e.target.value })} />
                            <div style={{ position: 'absolute', top: 1, right: 30 }}>
                              <GetIcon icon="LuSearch" style={{ color: BlueCrayola }} />
                            </div>
                          </div>
                          {subjects.map((subjects_v, subjects_i) => {
                            if (searchSubject && !subjects_v.acs_name.toLowerCase().includes((searchSubject).toLowerCase())) {
                              return null
                            }
                            return <div style={{ width: '33.33%' }} className='px-1 mb-2'>
                              <Card style={{ borderRadius: 25, borderWidth: 0, minHeight: 50, fontSize: 12 }} >
                                <Card.Body className='px-2 py-1 overflow-hidden position-relative cursor-pointer' >
                                  <div className='d-flex flex-row align-items-center'>
                                    <div style={{ width: 60, minWidth: 60 }} className='p-1'>
                                      <img src={(subjects_v.acs_image) ? getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_classmain_subject/' + subjects_v.acs_image : require('../../assets/images/noimage.png')} style={{ height: '100%', width: '100%', objectFit: 'contain' }} />
                                    </div>
                                    <div className='d-flex flex-column px-1 ms-1' style={{ height: '100%', flex: 1, borderLeft: 'solid 1px ' + AmericanSilver }}>
                                      <div className='d-flex flex-wrap flex-row' style={{ fontWeight: 'bold' }}>{subjects_v.acs_name}</div>
                                      {(subjects_v.acs_mandatory == 0) &&
                                        <div style={{ fontSize: 11, color: RedLustre }}>Elective</div>
                                      }
                                    </div>
                                    <div className='px-1'>
                                      <Link to={'/subject/' + subjects_v.acs_id}>
                                        <GetIcon icon="LuExternalLink" style={{ color: BlueCrayola }} />
                                      </Link>
                                    </div>
                                  </div>
                                </Card.Body>
                              </Card>
                            </div>
                          })}
                        </div>
                      }
                    </div>
                    {/* RIGHT */}
                    <div style={{ width: '30%', height: '100%', overflowY: 'auto' }}>
                      {/* Timetable */}
                      <Timetable />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container >
        <Offcanvas
          id='dashboard-ut'
          show={this.state.showUT} onHide={this.handleCloseUT} placement={(dir == 1) ? 'start' : 'end'} style={{ width: 500 }}>
          <Offcanvas.Body className='p-0'>
            <Timeline
              utWorking={utWorking}
              utTypes={utTypes}
              selectedUtTypes={selectedUtTypes}
              startDate={startDate}
              endDate={endDate}
              handleUtDateRange={this.handleUtDateRange}
              handleSelectUtTypes={this.handleSelectUtTypes}
              getTimeline={this.getTimeline}
              resetFilter={this.resetFilter}
              applyFilter={this.applyFilter}
              userTimelineData={userTimelineData}
              loadMore={loadMore}
              handleCloseUT={this.handleCloseUT}
            />
          </Offcanvas.Body>
        </Offcanvas>
        <button
          onClick={this.handleOpenUT}
          title={t('Open News Feed')}
          className='ut-toggle'>
          <FontAwesomeIcon icon={(dir == 1) ? faAngleRight : faAngleLeft} />
        </button>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  selectedChild: state.selectedChild.data,
  languages: state.language.languages,
  defaultLanguage: state.language.defaultLanguage,
})

const mapDispatchToProps = () => ({
  unsetAuthentication,
  setSelectedChild,
  setDefaultLanguage,
})

export default connect(mapStateToProps, mapDispatchToProps())(Dashboard)
